'use client'

import '@/bones/registry'

/** Registers pre-generated boneyard bones from `pnpm bones:build`. Side-effect only. */
export function BoneyardRegistryImport() {
  return null
}
